import React, { useLayoutEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../../providers/withRouter";
import Editar from "../../../../icons/editar.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModalEditar from "./EditarAlmacen";
import ModalEditarStock from "./../stock/EditarStock";
import { CircularProgress, Box } from "@mui/material";
import {
  getAlmacen,
  getProductosKae,
  getProductosKaeAlmacen,
} from "../../../../services";
import BreadCrumb from "../../../../components/navbar/Breadcrumb";
import { cambiarFormatoNombre } from "../../../../functions/funciones";
import { LuPackagePlus   } from "react-icons/lu";
import { UsuarioContext } from "../../../../providers/userContext";
import ListadoProductos from "./ListadoProductos";
import HistorialRegistros from "./HistorialRegistros";
import TransferirStock from "../stock/TransferirStock";
import { ArrowLeftRight } from "lucide-react";

const Almacen = (props) => {
  const { t } = useTranslation('common');
  const user = useContext(UsuarioContext);
  const [almacen, setAlmacen] = useState({});
  const [productos, setProductos] = useState({});
  const [modalEditarOpened, setModalEditarOpened] = useState(false);
  const [modalStockOpened, setModalStockOpened] = useState(false);
  const [modalTransferOpened, setModalTransferOpened] = useState(false);
  const [recargar, setRecargar] = useState(false);
  const [isLoading, setIsLoading] = useState(true)

  useLayoutEffect(() => {
    fetchData();
  }, [recargar]);
    
  const fetchData = async () => {
    await getProductosKaeAlmacen(props.params.id);
    getAlmacen(props.params.id).then((res) => {
    setAlmacen(res);
    setIsLoading(false);
    });
  };
  return isLoading ? <CircularProgress style={{color:'#92004D', position: 'absolute', top: '50%', left: '50%'}} /> :
    <>
      <ModalEditar
        almacen={almacen}
        opened={modalEditarOpened}
        handleClose={() => {
          setModalEditarOpened(false);
          setRecargar(!recargar);
        }}
      />
      <ModalEditarStock
        almacen={almacen}
        opened={modalStockOpened}
        handleClose={() => {
          setModalStockOpened(false);
          setRecargar(!recargar);
        }}
      />
      <TransferirStock
        almacenOrigenId={props.params.id}
        opened={modalTransferOpened}
        handleClose={() => {
          setModalTransferOpened(false);
        }}
        onSaved={() => {
          setModalTransferOpened(false);
          setRecargar(!recargar);
        }}
      />
      <BreadCrumb rutas={[{path:'/almacenes', label: t('almacenes.title')}, {path:`/almacenes/${props.params.id}`, label:`${almacen?.nombre}`}]} style={{ margin: '0 10px'}} />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">{t('almacenes.columns.almacen')}</div>
          <div className="gridSubhead editarSubhead">
            <div></div>
            <div className="btnsSubhead">
              <div className="editarBtn" onClick={() => setModalTransferOpened(true)} >
                <span style={{ marginRight: 10 }}>{t('almacenes.transfer.title')}</span>{" "}
                <ArrowLeftRight size={15} />
              </div>
              {(user.rol === "ADMIN" || user.rol === "VENT" || user.rol === "TECH" || user.rol === "TECH_COOR") && (
                <div className="editarBtn" onClick={() => setModalStockOpened(true)} >
                    <span style={{ marginRight: 10 }}>Stock</span>{" "}
                    <LuPackagePlus alt="stock" style={{"fontSize": 15}} />
                </div>
              )}
              {(user.rol === "ADMIN" || user.rol === "VENT") && (
                <div
                  className="editarBtn"
                  onClick={() => setModalEditarOpened(true)}
                >
                  <span style={{ marginRight: 10 }}>{t('actions.edit')}</span>{" "}
                  <img src={Editar} alt={t('actions.edit')} />
                </div>
              )}
            </div>
          </div>
          <div className="datosGrid">
            <p>
              <b>{t('almacenes.columns.almacen')}:</b> {almacen.nombre}
            </p>
            <p>
              <b>{t('almacenes.columns.address')}:</b> {almacen.direccion}
            </p>
            <p>
              <b>{t('almacenes.columns.municipality')}:</b> {cambiarFormatoNombre(almacen.municipio)}
            </p>
            <p>
              <b>{t('almacenes.columns.province')}:</b> {almacen.provincia}
            </p>
            <p>
              <b>{t('almacenes.columns.phone')}:</b> {almacen.telefono}
            </p>
          </div>
          <div className="gridSubhead">{t('almacenes.columns.signals')}</div>
            <ListadoProductos idAlmacen={props.params.id} recargar={recargar} setRecargar={setRecargar} />

          <div className="gridSubhead">{t('registros.title')}</div>
          <div className="pageContent tableContainer">
            <div className="tableWrapper">
              <Box className="pageContent">
                <HistorialRegistros almacenId={props.params.id} recargar={recargar} />
              </Box>
            </div>
          </div>

        </div>

      </div>
    </>
};

export default withRouter(Almacen);


